import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const VerticalArrowDropzoneIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 32",
    height: getDefaultHeight(svgProps, 32),
    ...svgProps,
    stroke: svgProps.stroke ?? "none",
    fill: color ?? svgProps.fill ?? "currentColor",
    children: /*#__PURE__*/jsx("path", {
      d: "M10.441 32s-.011 0 0 0a.71.71 0 0 1-.497-.203L.203 22.056A.703.703 0 0 1 .7 20.859h5.565v-5.565c0-.384.316-.7.7-.7s.7.316.7.7v6.265c0 .384-.316.7-.7.7H2.382l8.059 8.059 8.059-8.059h-4.583a.703.703 0 0 1-.7-.7v-6.265c0-.384.316-.7.7-.7s.7.316.7.7v5.565h5.565a.703.703 0 0 1 .497 1.197l-9.741 9.741a.73.73 0 0 1-.497.203zm3.476-18.782a.703.703 0 0 1-.7-.7V9.041c0-.384.316-.7.7-.7s.7.316.7.7v3.477a.71.71 0 0 1-.7.7zm-6.953 0a.703.703 0 0 1-.7-.7V9.041c0-.384.316-.7.7-.7s.7.316.7.7v3.477a.71.71 0 0 1-.7.7zm6.953-6.265a.703.703 0 0 1-.7-.7V4.176c0-.384.316-.7.7-.7s.7.316.7.7v2.088a.701.701 0 0 1-.7.689zm-6.953 0a.703.703 0 0 1-.7-.7V4.176c0-.384.316-.7.7-.7s.7.316.7.7v2.088a.701.701 0 0 1-.7.689zm6.953-4.865a.703.703 0 0 1-.7-.7V.699c0-.384.316-.7.7-.7s.7.316.7.7v.7a.709.709 0 0 1-.7.689zm-6.953 0a.703.703 0 0 1-.7-.7V.699c0-.384.316-.7.7-.7s.7.316.7.7v.7a.709.709 0 0 1-.7.689z"
    })
  });
};

export { VerticalArrowDropzoneIcon };
//# sourceMappingURL=dropzone.arrow.vertical.js.map
